import store from 'store'
import router from '../router'
import moment from 'moment-timezone'
import { SEC_TYPE } from 'const/stock'
import nProgress from 'nprogress'

let isTimeTraveling = false
let currentPath

export default {
  install(Vue) {
    // 个股页面跳转控制
    router.beforeEach((to, from, next) => {
      const isQuotePage = /^\/quote/.test(to.path)
      const symbolFromPath = to.params.symbol
      const activeStock = store.getters.activeStock
      if (isQuotePage) {
        if (symbolFromPath) {
          return next()
        }
        if (activeStock) {
          return next(getStockRoute(activeStock))
        }
        return fallbackNext(next)
      }
      return next()
    })

    // 添加进度条和中英文
    router.beforeEach((to, from, next) => {
      nProgress.start()
      if (to.query.lang) {
        Vue.config.lang = to.query.lang
      }
      next()
    })

    // 结束进度条
    router.afterEach(() => {
      nProgress.done()
    })

    // 保存路由信息
    router.afterEach((to, from) => {
      if (isTimeTraveling) {
        isTimeTraveling = false
        return
      }
      currentPath = to.fullPath
      store.commit('ROUTE_CHANGED', { to, from })
    })
    store.watch(
      function(state) {
        return state.route
      },
      function(route) {
        if (route.fullPath === currentPath) {
          return
        }
        isTimeTraveling = true
        currentPath = route.fullPath
        router.push(route)
      },
      { sync: true }
    )
  }
}

function fallbackNext(next) {
  const FALLBACK = '/quote/AAPL'
  const stock = store.getters.watchListAll[0]
  if (stock) {
    next(getStockRoute(stock))
  } else {
    next(FALLBACK)
  }
}

function getStockRoute(stock) {
  const isOption = stock.secType === SEC_TYPE.OPT
  if (isOption) {
    const expiry = moment(stock.expiry)
      .tz('America/New_York')
      .format('YYYYMMDD')
    return {
      path: `/quote/${stock.symbol}`,
      query: {
        expiry,
        strike: stock.strike,
        right: stock.right.toUpperCase()
      }
    }
  } else {
    return { path: `/quote/${stock.symbol}` }
  }
}
